import { Box, Typography, Paper } from '@mui/material';
import SimpleBarGraph from '../Graphs/SimpleBarGraph';
import { LoadingSpinner } from '../common/LoadingSpinner';
import { ErrorState } from '../common/ErrorState';
import { NoDataState } from '../common/NoDataState';

export const BirdsAtRiskOfCollisionCount = (props: any) => {
    const { isLoading, isError, error, hasData, birdsAtRiskData, header, subHeader, tickAmount } = props;
    const data = birdsAtRiskData || [];
  
    const transformedXAxisOptions = {
      categories: data.map((item: any) => item.date),
    };
  
    const transformedYAxisData = data.map(
      (item: any) => item.number_of_segments
    );

    // Show loading state
    if (isLoading) {
      return (
        <Paper
          className="custom-chart"
          sx={{
            minWidth: '1000px',
            maxWidth: '100%',
            minHeight: '800px',
            marginBottom: '7px',
            borderRadius: '16px',
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
            border: '1px solid rgba(229, 231, 235, 0.8)',
            background: 'linear-gradient(145deg, #ffffff 0%, #fafafa 100%)',
            overflow: 'hidden',
          }}
        >
          <LoadingSpinner 
            message="Loading collision risk data..." 
            height="800px"
            showBackground={false}
          />
        </Paper>
      );
    }

    // Show error state
    if (isError) {
      return (
        <Paper
          className="custom-chart"
          sx={{
            minWidth: '1000px',
            maxWidth: '100%',
            minHeight: '800px',
            marginBottom: '7px',
            borderRadius: '16px',
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
            border: '1px solid rgba(229, 231, 235, 0.8)',
            background: 'linear-gradient(145deg, #ffffff 0%, #fafafa 100%)',
            overflow: 'hidden',
          }}
        >
          <ErrorState 
            title="Failed to load collision risk data"
            error={error}
            height="800px"
            showBackground={false}
            onRetry={props.onRetry}
          />
        </Paper>
      );
    }

    // Show no data state
    if (!hasData) {
      return (
        <Paper
          className="custom-chart"
          sx={{
            minWidth: '1000px',
            maxWidth: '100%',
            minHeight: '800px',
            marginBottom: '7px',
            borderRadius: '16px',
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
            border: '1px solid rgba(229, 231, 235, 0.8)',
            background: 'linear-gradient(145deg, #ffffff 0%, #fafafa 100%)',
            overflow: 'hidden',
          }}
        >
          <NoDataState 
            title="No collision risk data available"
            message="No collision risk data found for the selected date range and filters. Try adjusting your selection criteria."
            height="800px"
            showBackground={false}
          />
        </Paper>
      );
    }
  
    return (
      <Paper
        className="custom-chart"
        sx={{
          minWidth: '1000px',
          maxWidth: '100%',
          minHeight: '800px',
          marginBottom: '7px',
          borderRadius: '16px',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
          border: '1px solid rgba(229, 231, 235, 0.8)',
          background: 'linear-gradient(145deg, #ffffff 0%, #fafafa 100%)',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: '20px',
          }}
        >
          <Typography sx={{ color: '#17052D' }} variant="h6">
            {header}
          </Typography>
          <Typography
            sx={{ color: '#8B8296', fontSize: '14px', marginBottom: '20px' }}
            variant="body2"
          >
            {subHeader}
          </Typography>
          <SimpleBarGraph
            xAxisOptions={transformedXAxisOptions}
            yAxisData={transformedYAxisData}
            graphWidth="100%"
            graphHeight={450}
            showGrid={true}
            tickAmount={tickAmount}
          />
        </Box>
      </Paper>
    );
  };
